import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Wrapper } from "src/types/wrapper";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
});

const QueryProvider: Wrapper = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default QueryProvider;
